import md1stScience from "./md1stScienceQuizContent";
import md1stSocialStudies from "./md1stSocialStudiesQuizContent";
import md1stMath from "./md1stMathQuizContent";
import md1stOther from "./md1stOtherQuizContent";

// 2nd Grade
import md2ndScience from "./md2ndScienceQuizContent";
import md2ndSocialStudies from "./md2ndSocialStudiesQuizContent";
import md2ndMath from "./md2ndMathQuizContent";
import md2ndOther from "./md2ndOtherQuizContent";

// 3rd Grade
import md3rdScience from "./md3rdScienceQuizContent";
import md3rdSocialStudies from "./md3rdSocialStudiesQuizContent";
import md3rdMath from "./md3rdMathQuizContent";
import md3rdOther from "./md3rdOtherQuizContent";

// 4th Grade
import md4thScience from "./md4thScienceQuizContent";
import md4thSocialStudies from "./md4thSocialStudiesQuizContent";
import md4thMath from "./md4thMathQuizContent";
import md4thOther from "./md4thOtherQuizContent";

// 5th Grade
import md5thScience from "./md5thScienceQuizContent";
import md5thSocialStudies from "./md5thSocialStudiesQuizContent";
import md5thMath from "./md5thMathQuizContent";
import md5thOther from "./md5thOtherQuizContent";
// ...import the rest as you add them

// Keep your existing keys ← these are what MapPage already uses
export const mdtopicsMapBySubject = {
  // 1st Grade
md_1st_science: md1stScience,
md_1st_socialstudies: md1stSocialStudies,
md_1st_math: md1stMath,
md_1st_other: md1stOther,

// 2nd Grade
md_2nd_science: md2ndScience,
md_2nd_socialstudies: md2ndSocialStudies,
md_2nd_math: md2ndMath,
md_2nd_other: md2ndOther,

// 3rd Grade
md_3rd_science: md3rdScience,
md_3rd_socialstudies: md3rdSocialStudies,
md_3rd_math: md3rdMath,
md_3rd_other: md3rdOther,

// 4th Grade
md_4th_science: md4thScience,
md_4th_socialstudies: md4thSocialStudies,
md_4th_math: md4thMath,
md_4th_other: md4thOther,

// 5th Grade
md_5th_science: md5thScience,
md_5th_socialstudies: md5thSocialStudies,
md_5th_math: md5thMath,
md_5th_other: md5thOther,
  // ...add the rest
};
